<template>
  <header class="ma-header">
    <div class="ma-header__inner">
      <!-- Logo -->
      <router-link :to="{ name: 'cliente-cliente-home' }" class="ma-header__logo">
        <img src="../../../../../assets/LogoColor2.png" alt="HIR Casa" />
      </router-link>

      <!-- Nav principal -->
      <nav v-if="mostrarMenu" class="ma-header__nav">
        <router-link :to="{ name: 'cliente-cliente-home' }" class="ma-header__link">Inicio</router-link>
        <router-link :to="{ name: 'cliente-cliente-financiamiento' }" class="ma-header__link">Financiamiento</router-link>
        <router-link :to="{ name: 'cliente-cliente-adjudicaciones' }" class="ma-header__link">Adjudicaciones</router-link>
        <router-link :to="{ name: 'cliente-cliente-materiales-apoyo' }" class="ma-header__link">Material de apoyo</router-link>

        <!-- Dropdown Seguros -->
        <div class="ma-header__dropdown" @mouseenter="dropdownOpen = true" @mouseleave="dropdownOpen = false">
          <button class="ma-header__link ma-header__link--dropdown">
            Seguros
            <i class="fas fa-chevron-down ma-header__dropdown-icon" />
          </button>
          <ul v-show="dropdownOpen" class="ma-header__dropdown-menu">
            <li v-for="seguro in seguros" :key="seguro.path">
              <button class="ma-header__dropdown-item" @click="irA(seguro.path)">{{ seguro.name }}</button>
            </li>
          </ul>
        </div>
      </nav>

      <!-- Acciones derecha -->
      <div v-if="mostrarMenu" class="ma-header__actions">
        <button class="ma-header__bell" aria-label="Notificaciones">
          <i class="far fa-bell" />
        </button>

        <span class="ma-header__user-chip">
          {{ store.nombreCompletoCliente }}
          <i class="far fa-user ma-header__user-icon" />
        </span>

        <button class="ma-header__salir" @click="salir">Salir</button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '../../../store'
import api from '@/servicios/apiCliente'

defineProps<{ mostrarMenu?: boolean }>()

const store = useStore()
const router = useRouter()
const dropdownOpen = ref(false)

const seguros = ref([
  { path: 'cliente-cliente-seguro-vida', name: 'Vida' },
  { path: 'cliente-cliente-seguro-danios', name: 'Daños' },
  { path: 'cliente-cliente-siniestro-generales', name: 'Siniestros' }
])

function irA(name: string) {
  dropdownOpen.value = false
  router.push({ name })
}

async function salir() {
  await api.Cliente.Cliente.HomeApi.Logout()
  store.sesionIniciada = false
  await router.push({ name: 'cliente-cliente-login' })
  window.sessionStorage.clear()
  window.location.reload()
}
</script>

<style scoped>
.ma-header {
  background-color: var(--ds-grey-50);
  box-shadow: var(--ds-shadow-sm);
  padding: 10px 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.ma-header__inner {
  max-width: 1208px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 32px;
}

.ma-header__logo img {
  height: 48px;
  width: auto;
}

.ma-header__nav {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
}

.ma-header__link {
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-subtitle7-size);
  font-weight: var(--ds-subtitle7-weight);
  color: var(--ds-secondary-main);
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.ma-header__link:hover,
.ma-header__link.router-link-active { color: var(--ds-primary-main); }

/* Dropdown */
.ma-header__link--dropdown {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ma-header__dropdown { position: relative; }

.ma-header__dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: var(--ds-grey-50);
  border-radius: var(--ds-radius-menu);
  box-shadow: var(--ds-shadow-menu);
  padding: 12px;
  list-style: none;
  margin: 0;
  min-width: 160px;
}

.ma-header__dropdown-item {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-subtitle13-size);
  font-weight: var(--ds-subtitle13-weight);
  color: var(--ds-text-primary);
  padding: 8px;
  border-bottom: 1px solid #BFC0C1;
}
.ma-header__dropdown-item:last-child { border-bottom: none; }
.ma-header__dropdown-item:hover { background-color: var(--ds-purple-50); border-radius: 8px; }

/* Acciones */
.ma-header__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.ma-header__bell {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--ds-grey-700);
  font-size: 18px;
}

.ma-header__user-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--ds-purple-main);
  color: #ffffff;
  border-radius: 16px;
  padding: 8px 16px;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-subtitle8-size);
  font-weight: var(--ds-subtitle8-weight);
  white-space: nowrap;
}

.ma-header__salir {
  background: none;
  border: 1px solid var(--ds-secondary-main);
  border-radius: var(--ds-radius-button);
  color: var(--ds-secondary-main);
  cursor: pointer;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-subtitle8-size);
  font-weight: var(--ds-subtitle7-weight);
  padding: 8px 20px;
  transition: background-color 0.2s;
}
.ma-header__salir:hover {
  background-color: var(--ds-secondary-50);
}
</style>
